import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import rekon_logo from '../assets/images/rekon_logo.png'
import doktrak_logo from '../assets/images/doktrak_logo.png'
import favicon16 from "../assets/images/favicon16.png";
import favicon32 from "../assets/images/favicon32.png";
import favicon64 from "../assets/images/favicon64.png";
import favicon from "../assets/images/favicon.ico";

const Event = ({ data }) => {
  return !!data.link ? (
 <a href={data.link} className="event" target="_blank" rel="noopener noreferrer">
   <div className="title">{data.title}</div>
   <div className="event-venue">{data.venue}</div>
   <div className="event-location">{data.location}</div>
   <div className="event-sub-location">{data.sub_location}</div>
   <div className="event-dates">{data.dates}</div>
  </a>
  ) : (
  <div className="event">
    <div className="title">{data.title}</div>
    <div className="event-venue">{data.venue}</div>
    <div className="event-location">{data.location}</div>
    <div className="event-sub-location">{data.sub_location}</div>
    <div className="event-dates">{data.dates}</div>
  </div>
  )
}
const IndexPage = ({ data }) => (
  <div>
    <Helmet
      title="Rekon Technologies"
      meta={[
        { name: 'description', content: 'Rekon Technologies: Lien Releases. Assignments. Documents. Files. All handled with precision and automation.' }
      ]}
       link={[
        { rel: "icon", type: "image/png", sizes: "16x16", href: `${favicon16}` },
        { rel: "icon", type: "image/png", sizes: "32x32", href: `${favicon32}` },
        { rel: "shortcut icon", type: "image/png", href: `${favicon64}` },
        { rel: "shortcut icon", type: "image/x-icon", href: `${favicon}` },
       ]}
    />
    <section className="hero hero-home is-primary">
      <div className="hero-body home-body-bg">
        <div className="container">
          <strong className="block line-1">
            {data.pagesYaml.hero.line_1}
          </strong>
          <strong className="block line-2">
            {data.pagesYaml.hero.line_2}
          </strong>
        </div>
      </div>
    </section>
    <div className="section">
      <section className="container is-fullhd has-middle-border product-choice-container">
        <div className="columns is-mobile is-multiline has-text-centered">
          <div className="column is-half-widescreen">
            <h1>{data.pagesYaml.product_text.rekon_text}</h1>
            <img src={rekon_logo} alt="Rekon Logo"/>
            <Link to="/rekon" className="button is-primary is-large">
              {data.pagesYaml.button_text.to_rekon}
            </Link>
          </div>
          <div className="column is-half-widescreen">
            <h1>{data.pagesYaml.product_text.doktrak_text}</h1>
            <img src={doktrak_logo} alt="DokTrak Logo"/>
            <Link to="/doktrak" className="button is-success is-large">
              {data.pagesYaml.button_text.to_doktrak}
            </Link>
          </div>
        </div>
      </section>
    </div>
    <section className="hero is-default container-testimonials">
      <div className="hero-body has-text-centered">
        <h2 className="title h2">{data.pagesYaml.testimonial_section.title}</h2>
        <blockquote>
          <p>{data.pagesYaml.testimonials[0].testimonial}</p>
          <small>{data.pagesYaml.testimonials[0].testimonee}</small>
        </blockquote>
      </div>
    </section>
    <section className="hero container-upcoming-events">
      <div className="hero-body">
        <div className="container is-fullhd">
          <div className="column is-5-desktop is-offset-6-desktop">
            <h2 className="title">Upcoming Events</h2>
            <p>Schedule time to meet us at one of the following events:</p>
              {data.pagesYaml.events.map((event, idx) => <Event key={idx} data={event} />)}
          </div>
        </div>
      </div>
    </section>
    <div className="section">
      <section className="container container-alliances">
        <div className="columns is-multiline is-centered">
          {data.pagesYaml.alliances.map((alliance, idx) => (
            <div key={idx} className="column">
              <img
                src={__PATH_PREFIX__ + alliance.logo_path}
                alt={alliance.description}
                style={{
                  width: eval(alliance.logo_width * 0.5) + 'px',
                  height: eval(alliance.logo_height * 0.5) + 'px'
                }} />
            </div>
          ))}
        </div>
      </section>
    </div>
  </div>
)

export const query = graphql`
query IndexQuery {
  pagesYaml {
    hero {
      line_1
      line_2
    }
    product_text {
      rekon_text
      doktrak_text
    }
    button_text {
      to_rekon
      to_doktrak
    }
    testimonial_section {
      title
    }
    testimonials {
      testimonee
      testimonial
    }
    events {
      title
      venue
      location
      # For events with sub_location E.G. Booth
      # sub_location
      dates
      link
    }
    alliances {
      logo_path
      description
      logo_width
      logo_height
    }
  }
}
`

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js